// image size for tmdb
//export  const img_300 = "https://image.tmdb.org/t/p/w300";
export  const  img_300 = "https://image.tmdb.org/t/p/w300";
export  const  img_500 = "https://image.tmdb.org/t/p/w500";

//contentModal and singleModal
export const unavailable = "https://www.movienewz.com/img/films/poster-holder.jpg"

// contentModal
export const unavailableLandscape = "https://media.istockphoto.com/vectors/image-unavailable-icon-vector-id1199906477";

// for Carousal
export const noPicture = "https://dummyimage.com/300x150/000/fff&text=no%20photo"